import { render, staticRenderFns } from "./component_rule_mobile.vue?vue&type=template&id=24f94344&scoped=true&"
import script from "./component_rule_mobile.vue?vue&type=script&lang=js&"
export * from "./component_rule_mobile.vue?vue&type=script&lang=js&"
import style0 from "./component_rule_mobile.vue?vue&type=style&index=0&id=24f94344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f94344",
  null
  
)

export default component.exports